<template>
    <router-link class="nav-btn" :to="to">
        <span><slot></slot></span>
    </router-link>
</template>

<script>
    export default {
        props: ['to']
    }
</script>